/**
 * 회원사업무문의 등록 폼페이터
*/
export class FormDataMemberCompanyInquiry {
    /** 글 아이디 */
    id = '';
    /** 제목 */
    title = '';
    /** 내용 */
    body = '';
    /** 게시물구분 */
    processingType = '';
    /** 작성자 name */
    createdByName = '';
    constructor(data) {
        if (!data) {
            return;
        }
        // get set 없이 딱 필드만 있게 하기 위해 중간에 처리
        const cls = new FormDataMemberCompanyInquiry();
        Object.getOwnPropertyNames(cls).forEach((it) => {
            const value = data[it];
            this[it] = value;
        });
    }
}
